var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUpArrow = function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1.533.6 5.2A.5.5 0 0 0 1 6h7a.5.5 0 0 0 .4-.8L4.9.533a.5.5 0 0 0-.8 0Z",
    fill: "currentColor"
  })));
};
export { SvgUpArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOSA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4xIDAuNTMzMzMzTDAuNiA1LjJDMC4zNTI3ODYgNS41Mjk2MiAwLjU4Nzk3NyA2IDEgNkg4QzguNDEyMDIgNiA4LjY0NzIxIDUuNTI5NjIgOC40IDUuMkw0LjkgMC41MzMzMzNDNC43IDAuMjY2NjY3IDQuMyAwLjI2NjY2NyA0LjEgMC41MzMzMzNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";